import React from 'react'
import styled from 'styled-components'
import FormLabel from '@material-ui/core/FormLabel'
import FormControl from '@material-ui/core/FormControl'
import FormGroup from '@material-ui/core/FormGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormHelperText from '@material-ui/core/FormHelperText'
import Checkbox from '@material-ui/core/Checkbox'


interface Props {
  label: string,
  value: any[],
  onChange(value: any[]): void,
  options?: {value: string, label: string}[],
  disabled?: boolean,
}

const FormModalCheckboxGroup = (props: Props) => {
  const {
    label,
    value,
    options = [],
    onChange,
    disabled,
  } = props
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let final: typeof value = value.slice()
    if (!event.target.checked) {
      final.splice(final.findIndex((item: any) => item === event.target.name), 1)
    } else {
      final.push(event.target.name)
    }
    onChange(final)
  }

  return <FormControl component='fieldset'>
    <FormLabel component='legend'>{label}</FormLabel>
    <FormGroup>
      { options.map((option,index) => {
          return <FormControlLabel
          disabled={disabled}
           key={option.value+'_lbl_'+index}
          label={option.label}
          control={
            <Checkbox 
              key={option.value+'_chk_'+index}
              checked={value.some(valueItem => valueItem === option.value)} 
              onChange={handleChange}
              name={option.value} 
            />
          }
        />
      })}
    </FormGroup>
    {/* <FormHelperText>You can display an error</FormHelperText> */}
  </FormControl>
}

const Wrapper = styled.div`

`

export default FormModalCheckboxGroup